import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ngx-botoes-whitelabel',
  templateUrl: './botoes-whitelabel.component.html',
  styleUrls: ['./botoes-whitelabel.component.scss'],
})
export class BotoesWhiteLabelComponent implements OnInit {

  @Output() actionButtonConfirm: EventEmitter<void> = new EventEmitter();
  @Output() actionButtonCancel: EventEmitter<void> = new EventEmitter();
  @Input() textButtonConfirm: string;
  @Input() textButtonCancel: string;
  @Input() colorButton?: {confirm: string, cancel: string};
  @Input() disableButtonContinuar: boolean = false;
  @Input() showButtonCancelar: boolean = true;
  @Input() showButtonContinuar: boolean = true;
  public customLogin;

  ngOnInit(): void {
    const resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
  }

  confirm(): void {
    this.actionButtonConfirm.emit();
  }

  cancel(): void {
    this.actionButtonCancel.emit();
  }

  getButtonPrimaria() {
    if (this.colorButton) {
      return this.colorButton.confirm;
    }

    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.colorButton) {
      return this.colorButton.cancel;
    }

    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }
}
